import React, { useState,useEffect } from "react";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
/* import Paging from "../../components/includes/Paging"; */
import { unescapeHtml} from "../../components/common/Common";

import faqIcon from "../../img/icon/icon-faq-quest.svg";

//질의 답변
const Faq = () => {
  //let mem_idx = Number(localStorage.getItem('mem_idx'));
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  //질의 답변 목록
  const [varFaqList,setFaqList] = useState([]);
  //분류
  const [varFaqType,setFaqType] = useState(0);
  
  //질의 답변 목록 호출
  const GetFaqList = async(itype) => {
    const sendData = {boardMode:3,itype:itype,pageNum:0,pageSize:0};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/parent_get_board_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const faqList = datas.results;
        setFaqList(faqList);
      } else {
        alert(datas.message);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    GetFaqList(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //분류
  const onChangeBoardTypeHandler = (e,itype) => {
    setFaqType(itype);
    GetFaqList(itype);
  }

  //내용보기/닫기
  const onToggleCommentHandler = (e,board_idx) => {
    const titleBox = e.currentTarget;
    console.log(titleBox);
    //설명부 오픈
    const commentBox = titleBox.parentNode.querySelector('.txt-con');
    console.log(commentBox);
    if(commentBox.classList.contains('open')) commentBox.classList.remove('open');
    else commentBox.classList.add('open');
    //제목부 화살표
    const onlytitletBox = titleBox.querySelector('.top-tit');
    if(onlytitletBox.classList.contains('on')) onlytitletBox.classList.remove('on');
    else onlytitletBox.classList.add('on');
  }

  return (
    <div className="vh-content normal-wrap">
      <HeaderUserTitle varPageTitle={'자주묻는 질문과 답변'} varBackString={'/Parents/MyPage'}/>
      <div className="vh-content-body">
        <div className="faq-wrap">	
          <div className="tab-menu-wrap mb30">
            <ul>
              <li className={varFaqType===0?"on":""} onClick={e=>onChangeBoardTypeHandler(e,0)}>전체</li>
              <li className={varFaqType===1?"on":""} onClick={e=>onChangeBoardTypeHandler(e,1)}>클래스</li>
              <li className={varFaqType===2?"on":""} onClick={e=>onChangeBoardTypeHandler(e,2)}>보강</li>
              <li className={varFaqType===3?"on":""} onClick={e=>onChangeBoardTypeHandler(e,3)}>로그인</li>
              <li className={varFaqType===4?"on":""} onClick={e=>onChangeBoardTypeHandler(e,4)}>기타</li>
            </ul>
          </div>
          {varFaqList.length===0?null:
            <div className="faq-con">					
              {varFaqList.map((faq,i)=>(
                <div className="f-box" key={'faq_'+i}>
                  <div className="top-wrap" onClick={e=>onToggleCommentHandler(e)}>
                    <div className="top-tit">
                      <img src={faqIcon} alt="" />
                      <span>{unescapeHtml(faq.board_title)}</span>
                    </div>
                  </div>
                  <div className="txt-con">{unescapeHtml(faq.board_comment)}</div>
                </div>
              ))}
            </div>          
          }
        </div>
      </div>
    </div>
  )
}
export default Faq;